export default {"src":"/_next/static/media/l2dao.0d1dd411.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};